import React, { useState } from "react";
import logo from "../logo.webp";
import { AuthData, Domains } from "./type/Data";
import { getAuth, getDomains } from "./services/Endpoints";
import { Button } from "antd";
import "./css/css.css";

interface Props {
  onLogin: (
    username: string,
    password: string,
    authResp: AuthData,
    domains: Domains[],
    isListing: boolean,
  ) => void;
}

const Login: React.FC<Props> = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const [isListing, setIsListing] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true); // Set loading state to true to disable the button and show loading indicator

    // const authResp: AuthData = {
    //     username: "",
    //     user: "",
    //     territory: "",
    //     domain: "",
    //     department: "",
    //     uid: "",
    //     login: "",
    //     scope: "",
    //     user_email: "",
    //     displayName: "",
    //     access_token: "a6d444d1e7f5ca35e4e447704e051684",
    //     expires_in: 0,
    //     token_type: "Bearer",
    //     refresh_token: "",
    //     client_id: "",
    //     apiversion: ""
    // };
    const authResp = await getAuth(username, password);

    console.log("login response", authResp);

    if (!username || !password) {
      setError("Please enter both username and password.");
      setLoading(false);
      return;
    }
    if (!authResp) {
      setError("Invalid credentials.");
      setLoading(false);
      return;
    }

    if (authResp) {
      const domainsResp: Domains[] = await getDomains(authResp);

      setLoading(false);
      onLogin(username, password, authResp, domainsResp, false);
    }
    setLoading(false);
  };

  const handleQuoteListing =  () => {
    console.log("listing clicked. . . .");
    onLogin("", "", {
      username: "",
      user: "",
      territory: "",
      domain: "",
      department: "",
      uid: "",
      login: "",
      scope: "",
      user_email: "",
      displayName: "",
      access_token: "",
      expires_in: 0,
      token_type: "",
      refresh_token: "",
      client_id: "",
      apiversion: ""
    }, [], true);
  }


  return (
    <div 
    // className="login-container" 
    style={{
      // display: "flex" ,
      // justify-content: "center",
      // align-items: "center",
      // height: "100vh",
      // background: "linear-gradient(#07d6ff, #fefefe18)",
      // box-shadow: "0 0 10px rgba(135, 5, 5, 0.1)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      background: "linear-gradient(#07d6ff, #fefefe18)",
      boxShadow: "0 0 10px rgba(135, 5, 5, 0.1)"
    }}
    >
      <div>
        <h1 style={{ textAlign: "center" }}>
          <img src={logo} className="App-logo" alt="logo" />
        </h1>
      </div>

      <form onSubmit={handleSubmit}>
        <div>
          <input
            className="input"
            type="text"
            id="username"
            value={username}
            placeholder="Net sapiens account"
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div>
          <input
            className="input"
            type="password"
            id="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button className="button" type="submit" disabled={loading}>
          {loading ? "Logging in..." : "Log In"}
        </button>
        {/* <Button onClick={handleQuoteListing}>Generate Quote Listing</Button> */}
        {error && <div className="error">{error}</div>}
      </form>
    </div>
  );
};

export default Login;
